<template>
  <div class="property_wrap formedit">
    <div class="pro_top">占位符</div>
    <div class="pro_con">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="分割高度">
          <el-slider v-model="property.height" show-input max="150"></el-slider>
        </el-form-item>
        <el-form-item label="分隔线">
         <el-radio-group v-model="property.radio"  @change="changetype">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="2">不显示</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
      form: {}
    };
  }
};
</script>
